/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMarketingCouponOfferDetails} from '../api'

 export const useQueryGetMarketingCouponOfferDetails = createReactQueryHook('getMarketingCouponOfferDetails', getMarketingCouponOfferDetails)
